import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcCoupon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.25 6a.25.25 0 0 0-.25-.25H4a.25.25 0 0 0-.25.25v3.356a2.748 2.748 0 0 1 0 5.286V18c0 .138.112.25.25.25h16a.25.25 0 0 0 .25-.25v-3.357a2.748 2.748 0 0 1 0-5.287zm1.5 4a.75.75 0 0 1-.75.75 1.25 1.25 0 1 0 0 2.5.75.75 0 0 1 .75.75v4A1.75 1.75 0 0 1 20 19.75H4A1.75 1.75 0 0 1 2.25 18v-4a.75.75 0 0 1 .75-.75 1.25 1.25 0 1 0 0-2.5.75.75 0 0 1-.75-.75V6c0-.966.784-1.75 1.75-1.75h16c.966 0 1.75.784 1.75 1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.53 14.53a.75.75 0 0 1-1.06-1.06l4-4a.75.75 0 1 1 1.06 1.06zM11 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0M15 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  }));
}
var IcCoupon = createNolIcon(/*#__PURE__*/forwardRef(SvgIcCoupon));

export { IcCoupon as I };
